const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

exports.months = months;

exports.toCanonical = (epochTime) => {
    const d = new Date(epochTime);
    if (!d) return null;
    return `${months[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
}